import React, { useState } from 'react';
import { AiFillDelete } from "react-icons/ai";
import axios from 'axios';
import Cookies from 'js-cookie';
import { decrpt } from '../../../component/encryption';

const ProductImgEditModal = (props) => {
  const [thumbLoading, setThumbLoading] = useState(null);

  let productID = props.allImages ? props.allImages.id : (props.selectedItems && props.selectedItems.id);
  let images = props.selectedItems && props.selectedItems.images;

  // Track the current thumb locally so it updates instantly without closing the modal
  const [localThumb, setLocalThumb] = useState(
    props.allImages ? props.allImages.main_image : (props.selectedItems && props.selectedItems.main_image)
  );

  const imageThumb = async (item) => {
    try {
      const data = {
        product_id: productID,
        image_id: item.id
      };
      setThumbLoading(item.id);
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/seller/product/make/thumb`, data);
      if (response.status === 200 || response.data.success) {
        // Update thumb locally — modal stays open, no jumping
        setLocalThumb(item.image);
      }
      setThumbLoading(null);
    } catch (error) {
      console.log(error, 'error setting thumb');
      setThumbLoading(null);
    }
  };

  return (
    <>
      <div>
        <div className="row">
          {/* Current Thumb */}
          <div className="col-md-2">
            <div style={{ position: 'relative' }}>
              <span className="badge text-dark bg-warning" style={{ position: "absolute", top: 5, left: 5, zIndex: 1 }}>
                Current Thumb
              </span>
              <img
                src={localThumb}
                style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 4 }}
                alt="Thumb"
              />
            </div>
          </div>

          {/* All product images */}
          {images && images.map((item, index) => {
            const isActiveThumb = (localThumb === item.image);
            return (
              <div className="col-md-2" key={index}>
                <div>
                  <img
                    src={item.image}
                    style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 4 }}
                    alt={`Product img ${index}`}
                  />
                  <div className="d-flex justify-content-center pt-2 gap-1 flex-wrap">
                    {isActiveThumb ? (
                      <span className="badge bg-success mb-1 w-100">Active Thumb</span>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-xs btn-success me-1"
                        disabled={thumbLoading === item.id}
                        onClick={() => imageThumb(item)}
                      >
                        {thumbLoading === item.id ? '...' : 'Set as Thumb'}
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-xs btn-danger"
                      onClick={() => props.handleDelete(item)}
                      title="Delete Image"
                    >
                      <AiFillDelete /> Delete
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Upload new image */}
        <div className="col-md-12 mt-3">
          {props.selectedItems && props.selectedItems.images && props.selectedItems.images.length >= 5 ? (
            <p className="text-danger mt-3 mb-0">
              * Maximum limit of 5 images reached. Delete an existing image to upload a new one.
            </p>
          ) : (
            <>
              {props.filePreview && props.filePreview.modalImage && (
                <div className="mb-3">
                  <label className="form-label fw-bold me-2">Selected Image Preview:</label>
                  <div style={{ border: '1px solid #ddd', borderRadius: 8, padding: 5, display: 'inline-block' }}>
                    <img
                      src={props.filePreview.modalImage}
                      style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: 6 }}
                      alt="New Upload Preview"
                    />
                  </div>
                </div>
              )}
              <label className="form-label label-txt">Upload New Image</label>
              <input
                type="file"
                name="image"
                id="file"
                className="form-control"
                onChange={props.handleChange}
                accept="image/*"
              />
              <small style={{ color: 'red', fontSize: 12 }}>
                * Select an image and click "Save Changes" to upload.
              </small>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductImgEditModal;